module.exports = __webpack_public_path__ + "static/media/Roboto-MediumItalic.cf23e1bb.ttf";